import { AxiosInstance } from 'axios';
import { ModuleDetails, ModuleOverview } from 'types/module';
import { Result } from 'services/Result';

export class ModulesService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getModules = async () => {
    const response = await this.axiosInstance.get<Result<{modules: ModuleOverview[]}>>(`api/modules`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data.modules;
    }
    throw Error('There was an internal error while fetching modules.');
  };

  getModuleDetails = async (id: string) => {
    const response = await this.axiosInstance.get<Result<ModuleDetails>>(`api/modules/${id}`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error('There was an internal error while fetching module details.');
  };
}

export default ModulesService;
